'use client';

import { COLORS } from '@/constants';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { Container } from './styled';
import { DashboardStatsSection, WelcomeBanner } from './components';

export const DashboardScreen: FC = () => {
  const t = useTranslations('dashboard');

  return (
    <Container>
      <Typography fontSize={30} fontWeight={700} color={COLORS['primary/900']} lineHeight={1} marginBottom={'22px'}>
        {t('title')}
      </Typography>

      <WelcomeBanner />

      <DashboardStatsSection />
    </Container>
  );
};
